"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInterfaceAdapter = exports.Web3Shim = void 0;
var shim_1 = require("./shim");
Object.defineProperty(exports, "Web3Shim", { enumerable: true, get: function () { return shim_1.Web3Shim; } });
var adapter_1 = require("./adapter");
Object.defineProperty(exports, "createInterfaceAdapter", { enumerable: true, get: function () { return adapter_1.createInterfaceAdapter; } });
//# sourceMappingURL=index.js.map